import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomInput from "./CustomInput";
import { resetPassword } from "../../libs";
const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const emailFromParams = searchParams.get("email") || "";
 
  const [form, setForm] = useState({
    email: emailFromParams,
    otp: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    if (
      !form.email ||
      !form.otp ||
      !form.newPassword ||
      !form.confirmPassword
    ) {
      toast.error("All fields are required");
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const response = await resetPassword({
        email: form.email.trim(),
        otp: form.otp.trim(),
        newPassword: form.newPassword,
      });

      if (response) {
        toast.success("Password reset successful");
        setTimeout(() => {
          navigate(`/`);
        }, 2100);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="logpage bg-primaryC py-4 min-h-screen">
      <div className={`glass my-5  w-[320px] mx-auto `}>
        <h3 className="text-center text-3xl mb-2">Reset Password</h3>
        <p className="text-center mb-4 xs:text-[15px]  text-[12px]">
          Enter the OTP sent to your email and choose a new password
        </p>
        <form onSubmit={handleSubmit}>
          <CustomInput
            type="text"
            label="Email Address"
            id="email"
            required="required"
            value={form.email}
            onChange={handleChange}
          />

          <CustomInput
            id="otp"
            type="text"
            label="OTP"
            placeholder="OTP"
            handleChange={handleChange}
            value={form.otp}
          />

          <CustomInput
            id="newPassword"
            type="password"
            label="New Password"
            placeholder="New Password"
            handleChange={handleChange}
            value={form.newPassword}
          />

          <CustomInput
            id="confirmPassword"
            type="password"
            label="Confirm New Password"
            placeholder="Confirm New Password"
            handleChange={handleChange}
            value={form.confirmPassword}
          />

          <div className="mb-3 text-right text-xs">
            {/* {!isSignup && <Link to='/forgot-password' className='font-bold'>Login</Link>} */}
          </div>
          <button
            className="rounded-2xl px-3 py-2 bg-indigo-500 text-white font-medium w-100 text-center text-decoration-none fs-5"
            type="submit"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
          <div className="text-xs mt-3 text-center">
            <p>
              ALready have an account?
              <Link to="/login" className="font-bold cursor-pointer text-right">
                {" "}
                Login
              </Link>
            </p>
          </div>
        </form>
      </div>
      <ToastContainer autoClose={2000} theme="colored" newestOnTop={true} />
    </div>
  );
};

export default ResetPassword;
